module.exports = __webpack_public_path__ + "img/Mask Group 1@2x.png";